<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="container">
    <div class="title">
        <h4>Listado de turnos</h4>
        <button type="button" class="btn btn-primary" routerLink="/addTurn">Agregar Turno</button>
    </div>

    <table *ngIf="listTurns.length > 0" class="table table-hover">
        <thead>
          <tr>
            <th scope="col">Nombre</th>
            <th scope="col">Descripción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listTurns" class="table-active">
            <td>{{ item.name }}</td>
            <td>{{ item.description }}</td>

            <td>
                <button routerLink="/editTurn/{{ item.id }}" type="button" class="btn btn-info btn-sm">Edit</button>
                <button (click)="deleteTurn(item.id!)" type="button" class="btn btn-secondary btn-sm ms-2">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 *ngIf="listTurns.length == 0">No hay turnos para mostrar</h5>
</div>
